import { LoadingStatusEnum } from '../../../constants/enums';

const initialState = {
  qrPdfTemplateList: [],

  loading: LoadingStatusEnum.Idle,
};

export default initialState;
